import React from "react";
import { Link } from "react-router-dom";
import { HOMEPAGE_BLOCK_IMAGES } from "@/data/serviceImages";

const ROOFING_ITEMS = [
  "Roof inspections",
  "Roof repairs",
  "Storm damage support",
  "Roof replacement",
  "Flashing & ventilation",
  "Leak detection",
];

export default function HomeRoofingBlock() {
  return (
    <section className="section-pad bg-br-black text-white">
      <div className="container-br grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="br-eyebrow text-br-bronze-2">Roofing</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Honest Roof Inspections & Repairs for Austin Homes</h2>
          <p className="mt-3 text-gray-300">Hail, wind, heat, and storms wear out Central Texas roofs faster than most homeowners expect. We inspect, document, and repair — and replace when it makes sense. We do not promise insurance approvals; we provide clear, honest options.</p>
          <ul className="mt-4 grid sm:grid-cols-2 gap-2 text-sm text-gray-300">
            {ROOFING_ITEMS.map((t) => (
              <li key={t} className="flex gap-2"><span className="text-br-bronze-2">▪</span> {t}</li>
            ))}
          </ul>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/roofing" className="br-btn-primary">Schedule a Roof Inspection</Link>
            <Link to="/services/roof-repair" className="br-btn-secondary">Roof Repair Details</Link>
          </div>
        </div>
        <div className="relative">
          <img src={HOMEPAGE_BLOCK_IMAGES.roofing} alt="Black Ridge roofers installing new shingles over ABC Pro Guard underlayment" className="rounded-md w-full object-cover aspect-[16/9]" />
          <div className="absolute inset-0 rounded-md bg-gradient-to-t from-black/30 via-transparent to-transparent" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}
